import cloudflareService from '@/common/services/cloudflareService';
import { SevenApiRoutes } from '@/modules/seven';
import axiosInstance from './axiosInstance';
import type { TboShiftLogResponse, TboShiftDetails } from './types';

/**
 * Gets 10 last shift logs
 */
const getShiftLog = (requestUuid: string) => axiosInstance.get<TboShiftLogResponse>(cloudflareService.generateCloudflareUrl(`${SevenApiRoutes.routes.tboMainUrl}shift/log`), {
  params: {
    requestUuid,
  },
});

const getShiftStatusByCashRegisterUuid = (params: {
  cashRegisterUuid: string,
  requestUuid: string,
}) => axiosInstance.get<TboShiftDetails>(cloudflareService.generateCloudflareUrl(`${SevenApiRoutes.routes.tboMainUrl}shift/status?cashRegisterUuid`), {
  params,
});

export {
  getShiftLog,
  getShiftStatusByCashRegisterUuid,
};
